type StackEvent = 'push' | 'pop' | 'update';

type Unsubscribe = () => void;
export interface IStack<T> {
  push: (item: T) => void;
  pop: () => T | null;
  subscribe: (event: StackEvent, callback: () => void) => Unsubscribe;
  update: (items: T[], isEqual: (a: T, b: T) => boolean) => void;
  top: T | null;
  size: number;
}

export class Stack<T> implements IStack<T> {
  private items: T[] = [];
  private subscribers: Record<StackEvent, Set<() => void>> = {
    push: new Set(),
    pop: new Set(),
    update: new Set(),
  };

  constructor(initialItems: T[] = []) {
    this.items = initialItems;
  }

  push(item: T): void {
    this.items.push(item);
    this.subscribers.push.forEach((callback) => callback());
  }

  pop(): T | null {
    const item = this.items.pop() ?? null;
    this.subscribers.pop.forEach((callback) => callback());
    return item;
  }

  update(items: T[], isEqual: (a: T, b: T) => boolean): void {
    const updatedItems = this.items.map((current) => {
      return items.find((i) => isEqual(i, current)) ?? current;
    });

    this.items = updatedItems;
    this.subscribers.update.forEach((callback) => callback());
  }

  subscribe(event: StackEvent, callback: () => void): Unsubscribe {
    this.subscribers[event].add(callback);

    return (): void => {
      this.subscribers[event].delete(callback);
    };
  }

  get top(): T | null {
    return this.items[this.items.length - 1] ?? null;
  }

  get size(): number {
    return this.items.length;
  }
}
